import { render, staticRenderFns } from "./LandingBanner.vue?vue&type=template&id=0bc9b5cd&"
import script from "./LandingBanner.vue?vue&type=script&lang=js&"
export * from "./LandingBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports